import React, { ReactNode, useEffect, useRef } from 'react';
import {
  createBrowserRouter,
  Navigate, Route, Routes, useLocation,
} from 'react-router-dom';
import Home from './home/home';
import useChannelTalk from '../hook/useChannelTalk';
import SinorPremiumPage from './sinorPremium/sinorPremiumPage';
import ProgramsPage from './programs/programsPage';
import MembersPage from './members/membersPage';
import EventPage from './event/eventPage';

import IntroduceCompany from './sinorPremium/introduceCompany';
import IntroduceManager from './sinorPremium/introduceManager';
import IntroduceProgram from './programs/introduceProgram';
import RequestConsult from './programs/component/requestConsult';
import MemberBoard from './members/memberBoard';
import EventDetailPage from './event/eventDetailPage';
import LoginPage from './auth/login/loginPage';
import PasswordChange from './auth/password/passwordChange';
import useAuth from '../hook/useAuth';
import MemberListPage from './auth/member/memberList/MemberListPage';
import MemberDetailPage from './auth/member/memberDetail/MemberDetailPage';

interface RouterType {
  rootRef: any
}

const Router: React.FC<RouterType> = (props: RouterType) => {
  const location = useLocation();
  const { user, checkingAuth } = useAuth();
  const authed = !!user;
  const previousRouter = useRef<string | null>(null);
  useEffect(() => {
    if (previousRouter.current !== null) {
      if (location.pathname !== previousRouter.current) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,react/destructuring-assignment
        props.rootRef.current?.scrollTo(0, 0);
      }
    }
    previousRouter.current = location.pathname;
  }, [location]);
  if (checkingAuth) {
    return null;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/company_introduce" element={<IntroduceCompany />} />
      <Route path="/manager_introduce" element={<IntroduceManager />} />
      <Route path="/program_introduce" element={<IntroduceProgram />} />
      <Route path="/consult" element={<RequestConsult />} />
      <Route path="/members" element={<MemberBoard />} />
      <Route path="/events" element={<EventPage />} />

      <Route path="/sirup_premium" element={<SinorPremiumPage />} />
      <Route path="/program" element={<ProgramsPage />} />
      <Route path="/sirup_member" element={<MembersPage />} />
      {/* <Route path="/events" element={<EventPage />} /> */}
      {/* <Route path="/events/:id" element={<EventDetailPage />} /> */}

      <Route path="/login" element={<LoginPage />} />
      <Route path="/password/reset" element={authed ? <PasswordChange /> : <Navigate to="/login"   />}  />
      <Route path="/recommend" element={authed ? <MemberListPage /> :  <Navigate to="/login"  />}  />
      <Route path="/recommend/detail" element={authed ? <MemberDetailPage /> :  <Navigate to="/login"  />}  />
    </Routes>
  );
};

export default Router;
